var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "#EDB23B"
    },
    d: "M384.885,380.759c-59.629,70.014-202.857,39.329-272.871-20.299 s-52.984-174.718,6.645-244.732s190.239-67.75,260.253-8.121S444.514,310.745,384.885,380.759z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6B38A"
    },
    d: "M166.298,131.692c0,0-9.173,43.59-12.876,57.965c-12.125,47.074-23.714,56.12-23.714,56.12 l-24.292,0.593v56.345h44.496c21.446,0,38.831-17.385,38.831-38.831V133.9c0-6.259-5.074-11.332-11.332-11.332l0,0 C172.006,122.568,167.352,126.388,166.298,131.692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DA3A9"
    },
    d: "M108.594,246.291c-1.6,21.41-1.82,41.52-1.62,56.42c0.19,15.31,0.82,25.11,0.82,25.11H0.124 v-105.95c30.06,3.94,109.22,15.44,109.1,16.72C108.994,241.171,108.785,243.741,108.594,246.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#CF8457",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M132.683,244.475l4.265-3.255 c7.929-6.051,13.614-14.573,16.157-24.217l5.805-22.019c1.582-6.002,7.723-9.591,13.729-8.024l0,0 c5.271,1.375,8.802,6.327,8.384,11.758l-2.752,35.771c0,0,11.723,23.445,1.302,43.851c-10.42,20.406-28.558,11.922-28.558,11.922"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#CF8457",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M163.867,197.253l-0.853,3.548 c-0.47,1.953,0.805,3.897,2.782,4.246l5.318,0.938c1.881,0.332,3.679-0.912,4.031-2.789l0.611-3.262 c0.483-2.575-0.445-5.305-2.595-6.802c-1.363-0.949-3.137-1.495-5.264-0.676C165.84,193.249,164.383,195.11,163.867,197.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#211208",
      strokeMiterlimit: 10
    },
    d: "M65.592,236.355c0,0-3.356,52.583,0.373,85.028"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#CF8457",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M166.469,141.754 c0,0,3.094,0.734,4.931-2.021c1.837-2.755,1.957-14.508,1.957-14.508"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#CF8457",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M166.298,131.692"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#211208",
      strokeMiterlimit: 10
    },
    cx: 83.558,
    cy: 312.079,
    r: 6.255
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1.11,
    y: 0.365,
    width: 499.087,
    height: 499.111
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000094604307747766289350000005857323411195619769_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000094604307747766289350000005857323411195619769_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C99932"
    },
    d: "M308.638,186.835c0,0,22.086,8.334,15.628,94.277c-7.152,95.17-17.847,112.741-17.847,112.741 S264.389,242.146,308.638,186.835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C99932"
    },
    d: "M312.786,191.549c0,0-22.426-2.78-46.34,23.17c-31.758,34.461-23.17,139.019-14.992,181.951 l61.332,0.681C312.786,397.351,296.431,267.873,312.786,191.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#593F2E"
    },
    d: "M240.411,328.428l7.255,260.085h49.099c0,0,24.819-80.458,22.873-255.589L240.411,328.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A441E"
    },
    d: "M294.897,184.678c0,0-36.954-1.43-54.711,58.672c-17.757,60.101-8.594,122.355-8.594,122.355 h20.81c0,0,3.708-47.309,10.163-81.305c7.259-38.233,40.454-93.638,40.454-93.638L294.897,184.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#211208",
      strokeMiterlimit: 10
    },
    d: "M299.345,372.95c0,0,2.55,154.912-6.989,218.112"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#211208"
    },
    d: "M287.48,472.468h-87.084c-3.859,0-6.988-3.128-6.988-6.988v-61.668 c0-3.859,3.129-6.988,6.988-6.988h87.084c3.859,0,6.988,3.129,6.988,6.988v61.668 C294.468,469.339,291.34,472.468,287.48,472.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#211208",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: "M257.579,380.83h-28.027 c-3.568,0-6.461,2.893-6.461,6.461v14.276h40.949v-14.276C264.04,383.723,261.148,380.83,257.579,380.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A441E"
    },
    d: "M230.436,371.649c0,0-0.077,21.407,15.472,21.407c9.787,0,10.58-3.812,11.407-20.484 L230.436,371.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#211208"
    },
    d: "M318.928,94.558c0,0-9.578-14.802-3.773-22.929c5.805-8.127,18.866,2.322,18.866,2.322 s1.672-12.804,10.669-12.514c8.997,0.29,13.262,9.902,13.262,9.902s9.749-9.747,17.152-7.604 c11.047,3.198,10.256,17.86,10.256,17.86s15.909-7.598,21.235,2.495c3.702,7.014-3.497,16.853-3.497,16.853 s11.61-4.644,13.351,1.161c1.742,5.805-7.256,9.288-7.256,9.288s8.583-0.96,8.129,6.711 c-0.479,8.101-13.614,13.136-16.226,12.846C398.484,130.659,356.95,94.267,318.928,94.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#211208"
    },
    d: "M311.881,165.198c0,0-11.875-4.176-6.304-37.843c7.937-47.962,18.271-51.727,49.095-49.551 c30.824,2.176,44.967,22.121,43.879,35.538c-1.088,13.418-14.868,21.758-14.868,21.758S323.848,170.638,311.881,165.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A441E"
    },
    d: "M294.897,184.678l22.423-30.722c0,0-9.791-2.482-9.791-13.78 c0-10.141,15.191-15.224,19.688-5.214c0.821,1.828,2.773,4.181,4.778,4.181c3.556,0,6.223,0.222,14.007-22.126 c4.511-12.953,43.511-14.924,54.165,7.014c5.493,11.312-16.064,63.722-44.198,71.537c-24.414,6.782-30.161-8.735-30.161-8.735 l-6.561,7.534c-4.512,5.182-15.546,7.998-24.04-7.142L294.897,184.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#211208",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M375.293,141.012l-6.72,13.142 c-0.201,0.392-0.044,0.881,0.357,1.064c1.337,0.612,3.947,2.316,3.481,6.17c-0.597,4.947-8.365,5.537-10.703,3.087"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#211208",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M350.836,143.695 c0,0-1.689,6.657,2.466,9.191c6.014,3.667,11.32-3.475,11.32-3.475"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3D220F",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M375.313,154.863 c0,0-0.943,6.754,3.088,8.523c5.492,2.411,8.651-3.656,8.651-3.656"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#211208",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M355.008,130.05 c0,0,5.59,3.668,12.174,1.675"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3D220F",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M386.759,143.285 c0,0,2.481,4.228,7.983,6.895"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#211208",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M344.274,179.822 c0,0,6.646,3.446,8.615,5.292"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#211208",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M323.29,141.112 c0,0-2.339-6.37-7.983-5.403"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#211208",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M319.585,146.417 c0,0-3.156-2.47-1.029-4.665c2.127-2.196,4.734-0.274,4.734-0.274"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#633718"
    },
    d: "M356.649,160.963c-1.076,2.248-4.542,2.83-7.741,1.299s-4.921-4.595-3.845-6.843 c1.076-2.248,4.542-2.83,7.741-1.299C356.003,155.651,357.725,158.714,356.649,160.963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#633718"
    },
    d: "M382.589,171.907c-1.076,2.248-4.542,2.83-7.741,1.299c-3.199-1.531-4.921-4.595-3.845-6.843 c1.076-2.248,4.542-2.83,7.741-1.299C381.944,166.595,383.665,169.658,382.589,171.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A441E"
    },
    d: "M233.645,358.479c0,0-4.11,7.604-3.21,13.17c0.9,5.566,30.673,5.566,30.673,5.566 s2.823-7.443,0-10.78c-2.823-3.337-10.523-7.443-10.523-7.443L233.645,358.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C99932"
    },
    d: "M304.685,197.32c0,0-8.516-5.66-9.787-12.642c-1.271-6.982-41.554-0.076-56.899,61.306 l36.446,13.428L304.685,197.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#211208",
      strokeMiterlimit: 10
    },
    d: "M261.285,341.802c0,0,39.458,2.864,57.277,0.637"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#211208",
      strokeMiterlimit: 10
    },
    d: "M241.366,234.506c0,0,30.227,11.254,31.936,12.322"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#211208",
      strokeMiterlimit: 10
    },
    d: "M279.799,234.555c0,0-6.738,13.476-9.866,23.583"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C99932"
    },
    d: "M251.676,439.948h-12.935c-0.868,0-1.571-0.703-1.571-1.571v-6.269 c0-0.868,0.704-1.571,1.571-1.571h12.935c0.868,0,1.571,0.703,1.571,1.571v6.269 C253.248,439.245,252.544,439.948,251.676,439.948z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#211208"
    },
    d: "M322.774,89.913c0,0-16.741-9.98-21.249-0.644c-4.507,9.336,6.439,12.878,6.439,12.878 s-9.98,1.288-8.693,7.405c1.288,6.117,5.473,6.439,5.473,6.439s-9.014,1.288-7.405,9.015s7.727,8.693,7.727,8.693L322.774,89.913 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#211208"
    },
    d: "M305.577,127.355c0,0-12.422,6.343-7.271,14.07c5.151,7.727,7.727,7.727,7.727,7.727 L305.577,127.355z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.384e45ff0f7a2d8e3cbbabdaf045e1ed.svg";
export { ForwardRef as ReactComponent };